/**
 * Easely.js - Final Production Entry Point
 * v1.0.4 - Expert Lifecycle & Scroll Sync
 * FIXED: Path resolution for Vite build
 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// CORRECTED PATHS: Pointing to the 'core' directory
import { Engine } from './core/engine';
import { registry } from './core/registry';
import { CONFIG } from './core/config';

const Easely = {
  version: "1.0.4",

  /**
   * Primary initialization method
   * @param {Object} options - Global animation overrides
   */
  init(options = {}) {
    // 1. Apply Global Overrides
    if (options.duration) CONFIG.DEFAULT_DURATION = options.duration;
    if (options.ease) CONFIG.DEFAULT_EASE = options.ease;

    // 2. Expert Handshake: Bridge Global & Local GSAP
    const activeGSAP = gsap || (typeof window !== 'undefined' ? window.gsap : null);
    const activeST = ScrollTrigger || (typeof window !== 'undefined' ? window.ScrollTrigger : null);

    if (activeGSAP && activeST) {
      activeGSAP.registerPlugin(activeST);
      console.log(`%c 🚀 Easely.js v${this.version} | Scroll Engine Active `, "color: #011627; background: #41EAD4; font-weight: bold; padding: 4px; border-radius: 4px;");
    }

    // 3. The Lifecycle Buffer
    // Ensures all images/fonts are painted before measuring scroll positions.
    const startEngine = () => {
      setTimeout(() => {
        Engine.scan();
        
        // Initial Refresh
        if (activeST) activeST.refresh();

        // Secondary Refresh: Handles layout shifts from slow-loading assets
        setTimeout(() => {
          if (activeST) {
            activeST.refresh();
            console.log("Easely: Scroll positions re-calculated and locked.");
          }
        }, 500);
      }, 150);
    };

    if (document.readyState === 'complete') {
      startEngine();
    } else {
      window.addEventListener('load', startEngine);
    }
  },

  /**
   * Re-scans the DOM and recalculates all ScrollTrigger markers
   */
  refresh() {
    const activeST = typeof window !== 'undefined' ? window.ScrollTrigger : null;
    Engine.scan();
    if (activeST) {
      activeST.refresh();
      console.log("Easely: Manual refresh complete.");
    }
  },

  /**
   * Clean up all animations and memory
   */
  destroy(element) {
    if (element) {
      registry.destroy(element);
    } else {
      registry.clearAll();
    }
  }
};

/**
 * UMD/CDN Compatibility
 */
if (typeof window !== 'undefined') {
  window.Easely = Easely;

  const currentScript = document.currentScript;
  if (currentScript && currentScript.hasAttribute('data-auto')) {
    Easely.init();
  }
}

export default Easely;
export { Easely };